exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3mdWzAVrq2m9sww1XqTNfM{display:inline-block;width:200px;height:40px;vertical-align:top;font-weight:400;color:\"[theme:neutralPrimary, default:#323130]\"}html[dir] ._3mdWzAVrq2m9sww1XqTNfM{padding:6px 4px 6px 4px}html[dir=ltr] ._3mdWzAVrq2m9sww1XqTNfM{text-align:left}html[dir=rtl] ._3mdWzAVrq2m9sww1XqTNfM{text-align:right}", ""]);
// Exports
exports.locals = {
	"attachmentInfoContainer": "_3mdWzAVrq2m9sww1XqTNfM"
};